import {
  Button,
  Chip,
  Grid,
  IconButton,
  makeStyles,
  Snackbar,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Theme,
  Tooltip,
  Typography,
  withStyles,
} from "@material-ui/core";
import * as React from "react";
import {useState} from "react";
import {SearchBar} from "src/components/sub-components/SearchBar";
import {primaryBlue, secondaryTextColor, white,} from "src/components/colors";
import {environment} from "src/environments/environment";
import * as _ from "underscore";
import {Alert, Pagination, PaginationItem} from "@material-ui/lab";
import {EditIconLarge, ExecuteIcon, FilterIcon, ListIcon, ViewIcon} from "src/components/Icons";
import {timeSince} from "../utils";
import FilterBar from "src/components/sub-components/FilterBar";
import ConfigureDevice from "src/components/sub-components/ConfigureDevice/ConfigureDevice";
import ViewConfiguration from "src/components/sub-components/ViewConfiguration";
import EditConfiguration from "src/components/sub-components/EditConfigureDevice/EditConfiguration";
import ExecuteCommandPopup from "src/components/sub-components/EditConfigureDevice/ExecuteCommandPopup";
import HistoryDevice from "src/components/sub-components/HistoryDevice/HistoryDevice";
import axios from "axios";
import useStyles from "src/app/maintenance/assets/styles";
import { LoadingScreen } from "src/components/sub-components/LoadingScreen";
import Cookies from "js-cookie";
import { getDeviceParameterConfiguration, getDeviceParameterConfigurationDetails } from "../testing-automation/api-helper/apiHelper";

export function RemoteManagerComponent(props) {
  const classes = localStyles();
  const style =  useStyles();
  const userId = Cookies.get("USER_ID");
  const [devices, setDevices] = useState([]);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [page, setPage] = useState(1);
  const [errorMessage, setErrorMessage] = useState("");
  const [allDevices, setAllDevices] = useState([]);

  const [open, setOpen] = useState(false);
  const [reqSuccess, setReqSuccess] = useState(true);

  //Filter sets
  const [product, setProduct] = useState("ALL");
  const [update, setUpdate] = useState("ALL");
  const [filterOpen, setFilterOpen] = useState(false);
  const [configureOpen, setConfigureOpen] = useState(false);

  //FilterOptions
  const [filterProduct, setFilterProduct] = useState([]);
  const [filterStatus, setFilterStatus] = useState([]);

  const [loadingScreen,setLoadingScreen]=useState(false);

  React.useEffect(() => {
    //getting states to default values
    setDevices([]);
    getAllConfiguredDevices();
  }, []);


  /*
  const getProjects = () => {
    setProjects([]);
    axios.get(`${environment.host}/user/${userId}/project`, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${Cookies.get("ACCESS_TOKEN")}`,
      },
    })
      .then((response) => {
        if (response.data.content) {
          setProjects(response.data.content);
        } else {
          setProjects([]);
        }
      })
      .catch((err) => {
        alert(err);
      });
  };

  React.useEffect(() => {
    if (projects.length > 0 && devices.length > 0) {
      let deviceAnnex = [];
      devices.map((device) =>
        projects.map((project) => {
          if (project.kits.includes(device.id)) {
            device["client"] = project.name;
            deviceAnnex.push(device);
          }
        })
      );
    }
  }, [projects, devices]);
  */
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  function getFilterOptions(content) {
    if (!content) return;
    var products = [];
    var statuses = [];
    content.map((item) => {
      if (item.productType) {
        products.push(item.productType);
      }
      if (item && item.lastUpdateStatus) {
        statuses.push(item.lastUpdateStatus);
      }
    });
    products = products.filter((value, index, self) => {
      return self.indexOf(value) === index;
    });
    statuses = statuses.filter((value, index, self) => {
      return self.indexOf(value) === index;
    });

    setFilterProduct(products);
    setFilterStatus(statuses);
  }



  const getAllConfiguredDevices = () => {
    setLoadingScreen(true);
    getDeviceParameterConfiguration("LIST")
      .then((content) => {
        if (content) {
          setAllDevices(content);
          setDevices(content);
          getFilterOptions(content);
        } else {
          setDevices([]);
          setAllDevices([]);
        }
        setLoadingScreen(false);
      })
      .catch((err) => {
        setLoadingScreen(false);
        alert(err);
      });
  };

  //Have to check if this is api i needed here
  //  React.useEffect(() => {
  //   const uId = Cookies.get("USER_ID");

  //   axios.get(`${environment.host}/core/product/configDetails`, {
  //     headers: {
  //       "Content-Type": "application/json",
  //       Authorization: `Bearer ${Cookies.get("ACCESS_TOKEN")}`,
  //     },
  //   })
  //     .then((response) => {
  //     })
  //     .catch((err) => {
  //     });
  // }, []);

  const handleOpen = () => {
    setFilterOpen(true);
  };

  const handleClose = () => {
    setFilterOpen(false);
  };

  const handleConfigureOpen = () => {
    setConfigureOpen(true);
  };

  const handleConfigureClose = () => {
    setConfigureOpen(false);
  };

  const [reviewOpen, setReviewOpen] = useState(false);
  const [editOpen, setEditOpen] = useState(false);
  const [updateOpen, setUpdateOpen] = useState(false);
  const [executeOpen,setExecuteOpen]=useState(false);
  const [selectedDevice, setSelectedDevice] = useState<any>(null);

  const handleEditOpen = (props) => {
    setLoadingScreen(true);
    getDeviceParameterConfigurationDetails(props.device.id)
      .then((details) => {
        setSelectedDevice({ device: details });
        setEditOpen(true);
        setLoadingScreen(false);
      })
      .catch((err) => {
        setLoadingScreen(false);
        alert("Error fetching device details: " + err);
      });
  };
  const handleEditClose = () => {
    setEditOpen(false);
    getAllConfiguredDevices();
  };
  const handleExecuteOpen = (props) => {
    setLoadingScreen(true);
    getDeviceParameterConfigurationDetails(props.device.id)
      .then((details) => {
        setSelectedDevice({ device: details });
        setExecuteOpen(true);
        setLoadingScreen(false);
      })
      .catch((err) => {
        setLoadingScreen(false);
        alert("Error fetching device details: " + err);
      });
  };
  const handleExecuteClose = () => {
    setExecuteOpen(false);
  }

  const handleReviewOpen = (props) => {
    setLoadingScreen(true);
    getDeviceParameterConfigurationDetails(props.device.id)
      .then((details) => {
        setSelectedDevice({ device: details });
        setReviewOpen(true);
        setLoadingScreen(false);
      })
      .catch((err) => {
        setLoadingScreen(false);
        alert("Error fetching device details: " + err);
      });
  };

  const handleReviewClose = () => {
    setReviewOpen(false);
  };

  const handleUpdateOpen = (props) => {
    setLoadingScreen(true);
    getDeviceParameterConfigurationDetails(props.device.id)
      .then((details) => {
        setSelectedDevice({ device: details });
        setUpdateOpen(true);
        setLoadingScreen(false);
      })
      .catch((err) => {
        setLoadingScreen(false);
        alert("Error fetching device history: " + err);
      });
  };

  function handleFilter(productType = "ALL", update = "ALL") {
    setLoadingScreen(true);
    getDeviceParameterConfiguration("LIST")
      .then((content) => {
        setLoadingScreen(false)
        if (!content) return;
        if (productType == "ALL" && update != "ALL") {
          const filterDevice = content.filter(
            (obj) =>
              obj &&
              obj.lastUpdateStatus &&
              obj.lastUpdateStatus.includes(update)
          );
          setDevices(filterDevice);
          setPage(1);
        }
        if (productType != "ALL" && update != "ALL") {
          const filterDevice = content.filter(
            (obj) =>
              obj.productType&&
              obj.lastUpdateStatus &&
              obj.productType.includes(productType) &&
              obj.lastUpdateStatus.includes(update)
          );
          setDevices(filterDevice);
          setPage(1);
        }
        if (productType != "ALL" && update == "ALL") {
          const filterDevice = content.filter(
            (obj) =>
              obj &&
              obj.productType &&
              obj.productType.includes(productType)
          );
          setDevices(filterDevice);
          setPage(1);
        }

        if (productType == "ALL" && update == "ALL") {
          getAllConfiguredDevices();
        }
      })
      .catch((err) => {
        setLoadingScreen(false);
        alert(err);
      });
  }

  const handleSearch = (e) => {
    const searchValue = e.target.value.toLowerCase();
    if (searchValue === "") {
      getAllConfiguredDevices();
    } else {
      // If searchValue is not an integer, filter devices by name, productType, or device id
      const searchDevice = allDevices.filter((device) => {
        const nameMatch = device.name.toLowerCase().includes(searchValue);

        const productIdMatch = device.product
          ? device.product.productType
            ? device.product.productType.toLowerCase().includes(searchValue)
            : false
          : false;

        const deviceIdMatch = device.id.toLowerCase().includes(searchValue);

        return nameMatch || productIdMatch || deviceIdMatch;
      });

      setDevices(searchDevice);
      setPage(1);

    }

  };

  return (
    <div className={`testing`}>
      <div className="page-heading">
        Remote Manager
      </div>
      {/* <div>{console.log('selectVersions', selectVersions)}</div> */}
      <Grid container className={style.container} spacing={2}>
        <Grid
          item
          xs={12}
          md={2}
          style={{
            textAlign: "right",
            display: "flex",
            //justifyContent: "right",
          }}
        >
          <SearchBar placeholder="Search" onChange={(e) => handleSearch(e)}/>
        </Grid>
        <Grid
          item
          xs={12}
          md={10}
          style={{
            color: "white",
            textAlign: "left",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <div style={{margin: 0}}>
            <Button
              variant="outlined"
              className={style.filter}
              onClick={handleOpen}
            >
              <span
                style={{
                  display: "flex",
                }}
              >
                {FilterIcon()}
              </span>
              <span>Filter</span>
            </Button>
            <FilterBar
              open={filterOpen}
              productType={product}
              update={update}
              setProductType={setProduct}
              setUpdate={setUpdate}
              onClose={() => handleClose()}
              productOptions={filterProduct}
              updateOptions={filterStatus}
              handleFilter={(productType, update) =>
                handleFilter(productType, update)
              }
            />
          </div>

          <div style={{margin: 0}}>
            <Button className={style.customButton}
              onClick={handleConfigureOpen}
            >
              Configure Device
            </Button>
            <ConfigureDevice
              open={configureOpen}
              onClose={() => handleConfigureClose()}
            />
          </div>
        </Grid>
        <Grid
          item
          xs={12}
          md={12}
        >
          <TableContainer>
            <Table size="small">
              <TableHead>
                <TableRow>
                  <TableCell
                    style={{
                      textAlign: "left",
                      borderBottomColor: "white",
                      borderTopColor: "white",
                      backgroundColor: "white",
                    }}
                  >
                    <div style={{display: "inline-flex"}}>
                      <Typography className={style.tablehead}
                        display="inline"
                      >
                        ID
                      </Typography>
                    </div>
                  </TableCell>
                  <TableCell
                    style={{
                      textAlign: "left",
                      borderBottomColor: "white",
                      borderTopColor: "white",
                      backgroundColor: "white",
                    }}
                  >
                    <div style={{display: "inline-flex"}}>
                      <Typography className={style.tablehead}
                        display="inline"
                      >
                        Device Name
                      </Typography>
                    </div>
                  </TableCell>
                  <TableCell
                    style={{
                      textAlign: "left",
                      borderBottomColor: "white",
                      borderTopColor: "white",
                      backgroundColor: "white",
                    }}
                  >
                    <div style={{display: "inline-flex"}}>
                      <Typography className={style.tablehead}
                        display="inline"
                      >
                        Updated Status
                      </Typography>
                    </div>
                  </TableCell>
                  <TableCell
                    style={{
                      textAlign: "left",
                      borderBottomColor: "white",
                      borderTopColor: "white",
                      backgroundColor: "white",
                    }}
                  >
                    <div style={{display: "inline-flex"}}>
                      <Typography className={style.tablehead}
                        display="inline"
                      >
                        Product Type
                      </Typography>
                    </div>
                  </TableCell>

                  <TableCell
                    style={{
                      textAlign: "left",
                      borderBottomColor: "white",
                      borderTopColor: "white",
                      backgroundColor: "white",
                    }}
                  >
                    <div style={{display: "inline-flex"}}>
                      <Typography className={style.tablehead}
                        display="inline"
                      >
                        Last Connected
                      </Typography>
                    </div>
                  </TableCell>
                  <TableCell
                    style={{
                      textAlign: "left",
                      borderBottomColor: "white",
                      borderTopColor: "white",
                      backgroundColor: "white",
                    }}
                  >
                    <div style={{display: "inline-flex"}}>
                      <Typography className={style.tablehead}
                        display="inline"
                      >
                        Created
                      </Typography>
                    </div>
                  </TableCell>
                  <TableCell
                    style={{
                      textAlign: "left",
                      borderBottomColor: "white",
                      borderTopColor: "white",
                      backgroundColor: "white",
                    }}
                  >
                    <div style={{display: "inline-flex"}}>
                      <Typography className={style.tablehead}
                      >
                        Actions
                      </Typography>
                    </div>
                  </TableCell>
                </TableRow>
              </TableHead>

              <TableBody>
                {devices.length > 0 &&
                  devices
                    .slice((page-1) * rowsPerPage, page * rowsPerPage )
                    .map((ele, i) => {
                      return (
                        <TableRow key={ele.id}>
                          <TableCell
                            style={{
                              textAlign: "left",
                              borderBottomColor: "white",
                              borderTopColor: "white",
                              backgroundColor:
                                i % 2 === 0 || i / 2 === 0
                                  ? "#F9F9F9"
                                  : "white",
                            }}
                          >
                            <Typography className={classes.tableText}>
                              {ele.id}
                            </Typography>
                            {/* <Typography className={classes.tableText}>{ele.product && ele.product.Date && ele.product.Date.toString().slice(0, 10)}</Typography> */}
                          </TableCell>
                          <TableCell
                            style={{
                              textAlign: "left",
                              borderBottomColor: "white",
                              paddingTop: "18px",
                              paddingBottom: "18px",
                              borderTopColor: "white",
                              backgroundColor:
                                i % 2 === 0 || i / 2 === 0
                                  ? "#F9F9F9"
                                  : "white",
                            }}
                          >
                            <Typography className={classes.tableText}>
                              {ele.name}
                            </Typography>
                          </TableCell>
                          <TableCell
                            style={{
                              textAlign: "left",
                              borderBottomColor: "white",
                              borderTopColor: "white",
                              backgroundColor:
                                i % 2 === 0 || i / 2 === 0
                                  ? "#F9F9F9"
                                  : "white",
                            }}
                          >
                            {ele.lastUpdateStatus &&
                              ele.lastUpdateStatus ===
                              "UPDATED" ? (
                                <Chip
                                  variant="outlined"
                                  className={classes.greenChip}
                                  label="Updated"
                                />
                              ):
                            (
                              ele.lastUpdateStatus  ===
                              "PENDING" ? (
                                <Chip
                                  variant="outlined"
                                  className={classes.yellowChip}
                                  label="Pending"
                                />
                              ):
                              (ele.lastUpdateStatus  ===
                              "FAILED" ? (
                                <Chip
                                  variant="outlined"
                                  className={classes.redChip}
                                  label="Failure"
                                />
                              ):
                              ele.lastUpdateStatus  ===
                              "PARTIALLY_UPDATED" ? (
                                <Chip
                                  variant="outlined"
                                  className={classes.redChip}
                                  label={"Partially \n updated"}
                                />
                              ):ele.lastUpdateStatus  ===
                              "CONFIGURING" ? (
                                <Chip
                                  variant="outlined"
                                  className={classes.blueChip}
                                  label={"Configuring"}
                                />
                              ):""))}
                          </TableCell>
                          <TableCell
                            style={{
                              textAlign: "left",
                              borderBottomColor: "white",
                              borderTopColor: "white",
                              backgroundColor:
                                i % 2 === 0 || i / 2 === 0
                                  ? "#F9F9F9"
                                  : "white",
                            }}
                          >
                            <Typography className={classes.tableText}>
                              {ele.productType ? ele.productType : ele.product.productType? ele.product.productType:""}
                            </Typography>
                          </TableCell>
                          <TableCell
                            style={{
                              textAlign: "left",
                              borderBottomColor: "white",
                              borderTopColor: "white",
                              backgroundColor:
                                i % 2 === 0 || i / 2 === 0
                                  ? "#F9F9F9"
                                  : "white",
                            }}
                          >
                            <Typography className={classes.tableText}>
                              {ele.product &&
                                ele.modifiedDate &&
                                timeSince(ele.modifiedDate)}
                            </Typography>
                          </TableCell>
                          <TableCell
                            style={{
                              textAlign: "left",
                              borderBottomColor: "white",
                              borderTopColor: "white",
                              backgroundColor:
                                i % 2 === 0 || i / 2 === 0
                                  ? "#F9F9F9"
                                  : "white",
                            }}
                          >
                            <Typography className={classes.tableText}>
                              {ele.deviceParameterConfiguration &&
                                ele.creationDate &&
                                timeSince(
                                  ele.creationDate
                                )}
                            </Typography>
                          </TableCell>
                          <TableCell
                            style={{
                              textAlign: "left",
                              borderBottomColor: "white",
                              borderTopColor: "white",
                              backgroundColor:
                                i % 2 === 0 || i / 2 === 0
                                  ? "#F9F9F9"
                                  : "white",
                            }}
                          >
                            <div style={{display: "inline-flex"}}>
                                <IconButton
                                  className={style.iconStyle}
                                  onClick={() =>
                                    handleReviewOpen({
                                      device: ele,
                                    })
                                  }title="View"
                                >
                                  <ViewIcon color = '#707070'/>
                                </IconButton>
                              {reviewOpen === true && (
                                <ViewConfiguration
                                  device={selectedDevice}
                                  open={reviewOpen}
                                  onClose={() => handleReviewClose()}
                                />
                              )}
                                <IconButton
                                  className={style.iconStyle}
                                  onClick={() =>
                                    handleEditOpen({
                                      device: ele,
                                    })
                                  }title="Edit"
                                >
                                  <EditIconLarge/>
                                </IconButton>
                              {editOpen === true && (
                                <EditConfiguration
                                  device={selectedDevice}
                                  open={editOpen}
                                  onClose={() => handleEditClose()}
                                />
                              )}
                              <IconButton
                                  className={style.iconStyle}
                                  onClick={() =>
                                    handleExecuteOpen({
                                      device: ele,
                                    })
                                  }title="Execute"
                                >
                                  <ExecuteIcon/>
                                </IconButton>
                                {executeOpen === true && (
                                <ExecuteCommandPopup
                                  device={selectedDevice}
                                  open={executeOpen}
                                  onClose={() => handleExecuteClose()}
                                />
                              )}
                                <IconButton
                                  className={style.iconStyle}
                                  onClick={() => {
                                    handleUpdateOpen({
                                      device: ele,
                                    });
                                  }}title="List"
                                >
                                  <ListIcon/>
                                </IconButton>
                              {updateOpen === true && (
                                <HistoryDevice
                                  device={selectedDevice}
                                  close={() => {
                                    setUpdateOpen(false);
                                  }}
                                />
                              )}
                            </div>
                          </TableCell>
                        </TableRow>
                      );
                    })}
              </TableBody>
            </Table>
          </TableContainer>
        </Grid>
        <Grid container justifyContent="center">
          {devices!== undefined && devices.length>rowsPerPage &&
        <Pagination className={style.pagination}
                    page={page}
                    onChange={handleChangePage}
                    count={devices !== undefined ? Math.ceil(devices.length / rowsPerPage) : 0}
                    shape="rounded"
                    defaultPage={1}
                    />
          }
        </Grid>
      </Grid>
      <Snackbar
        open={open}
        autoHideDuration={6000}
        anchorOrigin={{vertical: "bottom", horizontal: "right"}}
      >
        <Alert severity={reqSuccess === true ? "success" : "warning"}>
          <h3 style={{textAlign: "left"}}>
            {reqSuccess === true ? "Success" : "Error"}
          </h3>
          {reqSuccess
            ? "Successfully updated"
            : errorMessage.length > 0
              ? errorMessage
              : "Something went wrong"}
        </Alert>
      </Snackbar>
      <LoadingScreen loading={loadingScreen}/>
    </div>
  );
}

export const localStyles = makeStyles((theme: Theme) => ({
  root: {
    "&::-webkit-scrollbar": {
      display: "none",
    },
  },
  versionSelected: {
    backgroundColor: theme.palette.grey[50],
    border: `2px solid #2A7CED`,
    color: "#2A7CED",
    margin: "6",
  },
  version: {
    backgroundColor: theme.palette.grey[50],
    border: `1px solid #707170`,
    color: "#707170",
    margin: "6",
  },
  filter: {
    backgroundColor: white,
    color: secondaryTextColor,
    boxShadow: "none",
  },
  addFirmware: {
    backgroundColor: primaryBlue,
    color: white,
    boxShadow: "none",
    "&:hover": {
      backgroundColor: primaryBlue,
      color: white,
      boxShadow: "none",
    },
    [theme.breakpoints.down("md")]: {
      margin: "10px",
    },
  },
  tableText: {
    fontSize: "14px",
    color: "#3C3C3C",
  },
  versionCircleText: {
    fontSize: "10px",
  },
  versionText: {
    fontSize: "14px",
    color: "#2A7CED",
  },
  greenChip: {
    // backgroundColor: "#03C69F1F",
    border: "0px",
    color: "#03C69F",
    height: "20px",
  },

  versionChip: {
    // backgroundColor: "#e6edf7",
    border: "0px",
    color: "#2a7ced",
    height: "20px",
    // border: `1px solid #2A7CED`,
  },

  availableVersionChip: {
    // backgroundColor: "#fff",
    color: "#707070",
    height: "20px",
    border: "0px",
  },

  yellowChip: {
    // backgroundColor: "#FFB40A1F",
    color: "#FFB40A",
    height: "20px",
    border: "0px",
  },

  redChip: {
    // backgroundColor: "#FC41411F",
    color: "#EE3939",
    border: "0px",
    height: 'auto', 
    '& .MuiChip-label': {
      display: 'block',
      whiteSpace: 'pre-line', 
    },
  },

  blueChip: {
    color: "#2a7ced",
    height: "20px",
    border: "0px",
  },

  greenIndicator: {
    backgroundColor: "#03C69F1F",
    height: "20px",
    width: "30px",
  },
  redIndicator: {
    backgroundColor: "#FC41411F",
    height: "20px",
    width: "30px",
  },
  pagination:{
    alignItems:'center',
    position:"sticky",
    bottom:"5px"
  },
}));

const NewTooltip = withStyles({
  tooltip: {
    color: "black",
    backgroundColor: "white",
    boxShadow: "0px 3px 6px #00000029",
    padding: "10px",
  },
})(Tooltip);
